import Vue from 'vue';
import VueI18n from 'vue-i18n';
import languages from "./index.js";

if (!window.i18n) {
  Vue.use(VueI18n);
}

const i18n = new VueI18n({
  locale: "zh-CN", // 设置地区
  messages: {
    zh: languages.zh,
    en: languages.en,
  },
  silentTranslationWarn: true,
});

export const loadLocale = function (lang) {
  i18n.locale = lang; // 切换语言
}

export default i18n;